import React from "react";
import { MainContent, ModernWebLayout } from "../../components/Layout";
import { useLocation } from "react-router-dom";
import GuidelineContent from "../../components/Guideline/GuidelineContent";
import GuidelineLandingPage from "./GuidelineLandingPage";
import useScreenSize from "../../hooks/useScreenSize";

const generateSelfSearch = (pathname) => {
  const arraySearch = pathname.replace("/guidelines/", "").split("/");
  const [glPage, ...rest] = arraySearch;
  return { glPage, submenu: rest };
};

function isRootMenu(pathname, guidelineObj) {
  const regex = new RegExp(
    `^/(?:guidelines|app/nav)/${guidelineObj?.glPage}/?$`,
    "i",
  );
  return regex.test(pathname);
}

const ModernGuidelineNav = ({}) => {
  const { pathname, search } = useLocation();
  const guidelineObj = generateSelfSearch(pathname);
  const { isDesktop } = useScreenSize();
  const rootMenuPathname = `/guidelines/${guidelineObj?.glPage}`;

  return (
    <ModernWebLayout
      title="Guidelines - Therapeutic Guidelines"
      stickyPageSidebar={
        <GuidelineContent search={search} pathname={rootMenuPathname} />
      }
      showSidebar={isDesktop}
    >
      <MainContent padding="none">
        {!isDesktop && <GuidelineContent search={search} pathname={pathname} />}
        {isDesktop &&
          (isRootMenu(pathname, guidelineObj) ? (
            <GuidelineLandingPage />
          ) : (
            <GuidelineContent search={search} pathname={pathname} />
          ))}
      </MainContent>
    </ModernWebLayout>
  );
};

export default ModernGuidelineNav;